import {Directive, inject, input, TemplateRef} from "@angular/core";

@Directive({
  selector: '[proFormaDiscountLabel], [proFormaDiscountValue], [proFormaSubTotal]',
  standalone: false
})
export class HarbourDuesRotterdamProFormaValueDirective {
  readonly isDiscountLabel = input(false, {
    alias: 'proFormaDiscountLabel',
    transform: () => true
  });
  readonly isDiscountValue = input(false, {
    alias: 'proFormaDiscountValue',
    transform: () => true
  });
  readonly isSubTotal = input(false, {
    alias: 'proFormaSubTotal',
    transform: () => true
  });
  readonly template = inject(TemplateRef<any>);
}
